export const HeaderSection = {
  partners: 'Socios',
  accessories: 'Accesorios',
  stages: 'Etapas',
  order: 'Solicitar',
};
export const description =
  'Una casa inteligente es su asistente personal que se preocupa por su comodidad y confort. El sistema puede instalarse en cualquier lugar donde vivas o trabajes. Para controlarlo, basta con una tableta, un teléfono o un ordenador. Gracias a su exclusivo protocolo seguro y a su aplicación móvil, el complejo le garantiza el control total de sus instalaciones en cualquier momento. Para encender la luz, abrir las cortinas o apagar el aire acondicionado, no es necesario levantarse del sofá.';
